module.exports = __webpack_public_path__ + "img/favicon2.cb17c7f8.png";